import { render, staticRenderFns } from "./standardFormat.vue?vue&type=template&id=65454464&scoped=true&"
import script from "./standardFormat.vue?vue&type=script&lang=js&"
export * from "./standardFormat.vue?vue&type=script&lang=js&"
import style0 from "./standardFormat.vue?vue&type=style&index=0&id=65454464&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65454464",
  null
  
)

export default component.exports